import EventEmitter from 'events'
const GOOGLE_MAPS_KEY = process.env.GOOGLE_MAPS_KEY

class GoogleMaps extends EventEmitter {
  constructor () {
    super()
    this._url = 'https://maps.googleapis.com'
    this._path = '/maps/api/js'
    this._key = GOOGLE_MAPS_KEY
    this._libraries = 'drawing'
    this._callback = 'googleMapInit'
  }
  mountCallback () {
    window.googleMapInit = () => {
      this.emit('ready')
    }
  }
  load () {
    if (document.getElementById('google-maps-library')) {
      this.emit('ready')
      return false
    }
    this.mountCallback()
    let script = document.createElement('script')
    script.id = 'google-maps-library'
    script.setAttribute('async', '')
    script.setAttribute('defer', '')
    script.type = 'text/javascript'
    script.src = `${this._url}${this._path}?key=${this._key}&libraries=${this._libraries}&callback=${this._callback}`
    document.body.appendChild(script)
  }
}

export default new GoogleMaps()



// WEBPACK FOOTER //
// ./src/utils/google-maps-library.js